import { cn } from '@/shared/lib/utils';

interface InteraLogoProps {
  className?: string;
  width?: number;
  height?: number;
}

export const InteraLogo = ({
  className,
  width = 25,
  height,
}: InteraLogoProps) => {
  return (
    <span
      className={cn('inline-flex items-center gap-1 text-white', className)}
    >
      <img
        src="/intera_logo.svg"
        alt="Intera logomark"
        width={width}
        height={height}
        className="h-auto"
      />
      <span className="text-lg font-semibold text-white">INTERA</span>
    </span>
  );
};
